


















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SecurityService } from "@/services/SecurityService";
import SecureElementViewModel from "@/models/security/zorgID/secureElementViewModel";

@Component
export default class SecureElementComponent extends Vue {
  @Prop() private sessionId?: string;

  private secureElement: SecureElementViewModel = new SecureElementViewModel();

  private created() {
    this.subscribeToEvents();
  }

  private subscribeToEvents(): void {
    var me = this;
    SecurityService.getInstance().subscribeSecureElementRetrievedReceived(x => {
      me.secureElement = x;
    });
  }

  private hasSessionId(): boolean {
    return this.sessionId !== "" && this.sessionId !== undefined;
  }

  @Watch("sessionId")
  public watchSessionId(newSessionId: string, oldSessionId: string) {
    if (newSessionId !== "" && newSessionId !== undefined) {
      SecurityService.getInstance().retrieveSecureElement(newSessionId);
    } else {
      this.secureElement = new SecureElementViewModel();
    }
  }
}
